import React from 'react';
import _ from 'lodash';
import {withRouter} from 'react-router-dom';

import { connectProps } from 'store';
import { userIDProp } from 'model/component-props';

import Draggable from "react-draggable";

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import { Column, Table } from 'react-virtualized';

import convert from 'xml-js';

import content from './content';
import ItemCard from '../itemcard/ItemCard';
import spinner from '../../icons/spinner.svg'
import viewlist from '../../icons/view-list.png';
import gridview from '../../icons/grid-view.png';
import Searchbar from '../searchbar/Searchbar';
import Paging from '../paging/paging';
import './itemsList.css';


import {
    updateItemSearchKey,
    updateItemSearchTerm,
    updateViewOption,
    updateClassName,
    itemSearchKey,
    itemSearchTerm,
    updateItems,
    updateItemsNumber,
    items,
    updateProductID,
    langProp,
    currentPage,
    viewOption,
    className,
    itemsNumber,
  } from 'model/component-props';

  const TOTAL_WIDTH = 1200;

class Items extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sortBy: 'No',
            sortDirection: 'ASC',
            open: false,
            items: '50',
            widths: {
                No: 0.33,
                Description: 0.43,
                Sample_Description: 0.33,
                Inventory: 0.25,
                Special_Weight: 0.33,
                Composition: 0.33,
                Width: 0.23,
                Unit_Price: 0.43,
            }
        }
    }

    componentDidMount(){
        let dataAsJson = {};
        let id = this.props.userIDProp;
        if (_.isEmpty(id)) {
          id = window.sessionStorage.getItem('userID');
        }
        if (_.isEmpty(id)) {
          return this.props.history.push('/login');
        }


        if(this.props.items === null){
          fetch(`${process.env.REACT_APP_NODE_SERVER}/getItems`, {
              crossDomain: true,
              method: 'POST',
              headers: {
                  'Accept': 'text/xml',
                  'Content-Type': 'application/json',
              },
          })
          .then(response => response.text())
          .then(str => {
              dataAsJson = convert.xml2json(str, { compact: true, spaces: 4 });
              return JSON.parse(dataAsJson);
          })
          .catch(err => console.log(err))
          .then(data => this.props.updateItems(data));
      }
    }

    linkToDetails = () => {
        this.props.history.push('/details');
    }

    onItemCardClick = (id) => {
        this.props.updateProductID(id);
        this.linkToDetails();
    }

    changeViewOption = (ev, option) => {
        this.props.updateClassName(!this.props.className);
        this.props.updateViewOption(option);
    }

    handleChange = event => {
        this.props.updateItemsNumber(event.target.value);
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleOpen = () => {
        this.setState({ open: true });
    };

    sort = ({sortBy, sortDirection}) => {
      // console.log({sortBy, sortDirection})
      this.setState({
        sortBy,
        sortDirection,
      })
    }


    render(){
        if(!this.props.items) {
            return (
                <div className="container-itemsList">
                    <img src={spinner} alt="spinner" className="spinner" />
                </div>
            )
        }
        const {
            updateItemSearchKey,
            updateItemSearchTerm,
            itemSearchKey,
            itemSearchTerm,
            items,
            langProp,
            currentPage,
          } = this.props;
        const { widths } = this.state;
        const simplifiedData = items && _.get(items, ['Soap:Envelope', 'Soap:Body', 'ReadMultiple_Result', 'ReadMultiple_Result', 'ItemList']);
        const beautifiedData = _.map(simplifiedData, simple => _.reduce(simple, (r, value, key) => ({
          ...r,
          [key]: _.isString(value['_text']) ? value['_text'].trim() : value['_text']
        }), {}));
        const searchKeysList = ['No', 'Description', 'Inventory', 'Special_Weight', 'Composition', 'Width', 'Unit_Price'];
        const filteredData = beautifiedData && beautifiedData.filter(obj =>
          _.has(obj, itemSearchKey) && _.includes(obj[itemSearchKey].toLowerCase(), itemSearchTerm.toLowerCase()));

        const itemsPerPage = this.props.itemsNumber;
        const numberOfPages = Math.ceil(filteredData.length / itemsPerPage);
        const tempList = _.sortBy([...filteredData], d => {
          return this.state.sortBy === 'Inventory' || this.state.sortBy === 'Unit_Price'
          ? parseFloat(d[this.state.sortBy])
          : d[this.state.sortBy];
        });
        const list = this.state.sortDirection === 'DESC' ? tempList.reverse() : tempList;
        return (
            <div>
                <div className="container">
                    <RadioGroup
                        className={'radio'}
                        name={'view-option'}
                        value={this.props.viewOption}
                        onChange={this.changeViewOption}
                    >
                        <FormControlLabel value={'cards'} control={<Radio />} />
                        <img className="view" src={gridview}  alt="gridview"/>
                        <FormControlLabel value={'list'} control={<Radio />} />
                        <img className="view" src={viewlist}  alt="viewlist"/>
                    </RadioGroup>
                </div>



                    {!_.isEmpty(beautifiedData) && <Searchbar
                        searchKeysList={searchKeysList}
                        updateSearchKey={key => updateItemSearchKey(key)}
                        updateSearchTerm={term => updateItemSearchTerm(term)}
                        searchKey={itemSearchKey || _.head(searchKeysList)}
                        searchTerm={itemSearchTerm}
                    />
                    }
                    <div className={`paging-top-container ${this.props.className=== true ? 'appear' : 'hide'}`}>
                      <FormControl style={{paddingTop: '10px', paddingBottom: '15px', display: 'block'}}>
                              <InputLabel style={{position: 'inherit', fontSize: '13px'}} htmlFor="demo-controlled-open-select"></InputLabel>
                              <Select
                                  style={{width: '160px'}}
                                  open={this.state.open}
                                  onClose={this.handleClose}
                                  onOpen={this.handleOpen}
                                  value={this.props.itemsNumber}
                                  onChange={this.handleChange}
                                  inputProps={{
                                  name: 'items',
                                  id: 'demo-controlled-open-select',
                                  }}
                              >
                                  <MenuItem value={50}>Show 50</MenuItem>
                                  <MenuItem value={100}>Show 100</MenuItem>
                              </Select>
                        </FormControl>
                    </div>
                    <div className={`paging-top-container ${this.props.className=== true ? 'appear' : 'hide'}`}>
                        <div className='paging-top'><Paging numberOfPages={numberOfPages} /></div>
                    </div>

                { this.props.viewOption === 'cards'
                ? (
                      <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center'}}>
                        {
                          _.slice(filteredData, currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage).map((item, i) =>
                              {
                                  return (
                                          <ItemCard
                                              key={i}
                                              id={item.No}
                                              description={langProp === 'EN' ? (item.TranslateDescr || item.Description) : item.Description}
                                              sampledescription={item.Sample_Description}
                                              inventory={item.Inventory}
                                              weight={item.Special_Weight}
                                              composition={item.Composition}
                                              width={item.Width}
                                              //unitprice={item.Unit_Price}
                                              onClick={() => this.onItemCardClick(item.No)}
                                              url={`${process.env.REACT_APP_NODE_SERVER}/thumbs/${item.No}.JPG`} 
                                          />
                                  )

                              })
                        }
                      </div>
                    )
                : (
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <Table
                            style={{margin: '20px', backgroundColor: 'white', overflowX: 'scroll'}}
                            rowStyle={{border: '0.5px grey'}}
                            width={TOTAL_WIDTH}
                            height={500}
                            headerHeight={40}
                            headerStyle={{'color': 'white'}}
                            rowHeight={35}
                            rowCount={list.length}
                            rowGetter={({ index }) => list[index]}
                            sortBy={this.state.sortBy}
                            sortDirection={this.state.sortDirection}
                            sort={this.sort}
                            onRowClick={({ rowData }) => this.onItemCardClick(rowData.No)}
                        >
                            <Column
                                headerRenderer={this.headerRenderer}
                                label={content[langProp].ID}
                                dataKey= 'No'
                                width={widths.No * TOTAL_WIDTH}
                            />

                            <Column
                                headerRenderer={this.headerRenderer}
                                label={content[langProp].Description}
                                dataKey={langProp === 'EN' ? "TranslateDescr" || "Description" : "Description"}
                                width={widths.Description * TOTAL_WIDTH}
                            />

                            <Column
                                headerRenderer={this.headerRenderer}
                                label={content[langProp].SampleDescription}
                                dataKey='Sample_Description'
                                width={widths.Sample_Description * TOTAL_WIDTH}
                            />

                            <Column
                                headerRenderer={this.headerRenderer}
                                style={{textAlign: 'right'}}
                                label={content[langProp].Inventory}
                                //headerStyle={{textAlign: 'right'}}
                                cellDataGetter={({ rowData }) => parseFloat(rowData.Inventory).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                dataKey='Inventory'
                                width={widths.Inventory * TOTAL_WIDTH}
                            />

                            <Column
                                headerRenderer={this.headerRenderer}
                                //style={{textAlign: 'right', paddingRight: '20px'}}
                                //headerStyle={{textAlign: 'right', paddingRight: '20px'}}
                                label={content[langProp].SpecialWeight}
                                dataKey='Special_Weight'
                                width={widths.Special_Weight * TOTAL_WIDTH}
                            />

                            <Column
                                headerRenderer={this.headerRenderer}
                                label={content[langProp].Composition}
                                dataKey='Composition'
                                width={widths.Composition * TOTAL_WIDTH}
                            />

                            <Column
                                headerRenderer={this.headerRenderer}
                                style={{textAlign: 'right', paddingRight: '25px'}}
                                //headerStyle={{textAlign: 'right'}}
                                label={content[langProp].Width}
                                dataKey='Width'
                                width={widths.Width * TOTAL_WIDTH}
                             />

                            {/*<Column
                                headerRenderer={this.headerRenderer}
                                style={{textAlign: 'right', paddingRight: '15px'}}
                                headerStyle={{textAlign: 'right'}}
                                label={content[langProp].UnitPrice}
                                cellDataGetter={({ rowData }) => parseFloat(rowData.Unit_Price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                dataKey='Unit_Price'
                                width={widths.Unit_Price * TOTAL_WIDTH}
                            />*/}
                        </Table>
                    </div>
                )
            }
                <div className={`footer ${this.props.className=== true ? 'appear' : 'hide'}`}>
                    <div className="paging-bottom"><Paging numberOfPages={numberOfPages} /></div>
                </div>
            </div>
        );
    }

    headerRenderer = ({
        columnData,
        dataKey,
        disableSort,
        label,
        sortBy,
        sortDirection
      }) => {
        return (
          <React.Fragment key={dataKey}>
            <div className="ReactVirtualized__Table__headerTruncatedText">
              {label}
            </div>
            <Draggable
              axis="x"
              defaultClassName="DragHandle"
              defaultClassNameDragging="DragHandleActive"
              onDrag={(event, { deltaX }) =>
                this.resizeRow({
                  dataKey,
                  deltaX
                })
              }
              position={{ x: 0 }}
              zIndex={999}
            >
              <span className="DragHandleIcon">|</span>
            </Draggable>
          </React.Fragment>
        );
      };
    
      resizeRow = ({ dataKey, deltaX }) =>
        this.setState(prevState => {
          const prevWidths = prevState.widths;
          const percentDelta = deltaX / TOTAL_WIDTH;
    
          //const nextDataKey = dataKey === "No" ? "Name" : "Outstanding_Orders";

          /*const nextDataKey = dataKey => {
              if(dataKey === 'No'){
                nextDataKey === 'Description';
              } else if(dataKey === 'Description') {
                nextDataKey === 'Sample_Description';
              } else if(dataKey === 'Sample_Description') {
                nextDataKey === 'Inventory';
              } else if(dataKey === 'Inventory') {
                nextDataKey === 'Special_Weight';
              } else if(dataKey === 'Special_Weight') {
                nextDataKey === 'Composition';
              } else if(dataKey === 'Composition') {
                nextDataKey === 'Width';
              } else if(dataKey === 'Width') {
                nextDataKey === 'Unit_Price';
              }
            }*/

          return {
            widths: {
              ...prevWidths,
              [dataKey]: prevWidths[dataKey] + percentDelta,
              //[nextDataKey]: prevWidths[nextDataKey] - percentDelta
            }
          };
        });
}

export default connectProps(
    updateItemSearchKey,
    updateItemSearchTerm,
    updateViewOption,
    updateClassName,
    itemSearchKey,
    itemSearchTerm,
    updateItems,
    updateItemsNumber,
    items,
    updateProductID,
    langProp,
    currentPage,
    viewOption,
    className,
    itemsNumber,
    userIDProp
  )(withRouter(Items));



// WEBPACK FOOTER //
// ./src/components/itemlist/ItemsList.js